import React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
export function Edit1Liner24() {
  return /*#__PURE__*/_jsx("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /*#__PURE__*/_jsx("path", {
      d: "M12 1.99999H10C5 1.99999 3 3.99999 3 8.99999V15C3 20 5 22 10 22H16C21 22 23 20 23 15V13M15.91 4.14999C16.58 6.53999 18.45 8.40999 20.85 9.08999M17.04 3.01999L9.16 10.9C8.86 11.2 8.56 11.79 8.5 12.22L8.07 15.23C7.91 16.32 8.68 17.08 9.77 16.93L12.78 16.5C13.2 16.44 13.79 16.14 14.1 15.84L21.98 7.95999C23.34 6.59999 23.98 5.01999 21.98 3.01999C19.98 1.01999 18.4 1.65999 17.04 3.01999Z",
      stroke: "#696992",
      strokeWidth: "1.5",
      strokeMiterlimit: "10",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    })
  });
}